/**
 * TanStack Query hooks for `behavioral-anomaly-detection-abnormal-user-actions`.
 * Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	behavioralAnomalyQueryKeys,
	type CreateAnomalyEventBody,
	type ListAnomalyEventsResponse,
	type ListFilters,
} from "./api";

export function useAnomalyEventsList(
	filters: ListFilters = {},
): UseQueryResult<ListAnomalyEventsResponse, Error> {
	return useQuery({
		queryKey: behavioralAnomalyQueryKeys.list(filters),
		queryFn: () => list(filters),
	});
}

export function useAnomalyEventCreate(): UseMutationResult<
	{ ok: true },
	Error,
	CreateAnomalyEventBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: behavioralAnomalyQueryKeys.all });
		},
	});
}
